module.exports = __webpack_public_path__ + "static/Michal_1_min-58ceee1c26e40fdc4f4700d76a2e91c7.jpg";